import type { DataSourceFolderWithSubfoldersDTO } from '@conversed/rest/src/contracts/data-sources-folders/data-sources-folders.schema';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

export const useDataSourcesQueryParams = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const folderParam = searchParams.get('folder');
  const subfolderParam = searchParams.get('subfolder');

  const setSubfolderParam = useCallback(
    (subfolderKey?: string | null, folderKey?: string | null) => {
      const nextParams = new URLSearchParams(searchParams);
      if (subfolderKey) {
        nextParams.set('subfolder', subfolderKey);
        if (folderKey) {
          nextParams.set('folder', folderKey);
        }
      } else {
        nextParams.delete('subfolder');
      }
      const search = nextParams.toString();
      navigate({
        pathname: location.pathname,
        search: search ? `?${search}` : '',
      });
    },
    [searchParams, location.pathname, navigate],
  );

  const setSubfolderFromFolder = useCallback(
    (
      subfolderName: string,
      folder: DataSourceFolderWithSubfoldersDTO | null | undefined,
    ) => {
      if (!subfolderName) {
        return;
      }

      const folderNameKey = folder?.name || '';
      const translatedFolderName = folderNameKey
        ? t(folderNameKey as string, { defaultValue: folderNameKey })
        : folder?._id?.toString();
      setSubfolderParam(subfolderName, translatedFolderName);
    },
    [setSubfolderParam, t],
  );

  return {
    folderParam,
    subfolderParam,
    setSubfolderFromFolder,
  };
};
